import { CCard, CCardBody, CCol, CCardHeader, CRow } from '@coreui/react'
import {
    CChartBar,
    CChartDoughnut,
    CChartLine,
    CChartPie,
    CChartPolarArea,
    CChartRadar,
} from '@coreui/react-chartjs'
import { DocsCallout } from 'src/components'
import { toast } from 'react-toastify';
import { Button, Flex, Input, Upload, Select, Spin, Checkbox } from 'antd';
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { UploadOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import DatePicker, { utils } from '@hassanmojab/react-modern-calendar-datepicker';
import jquery from 'jquery';
import { useParams } from 'react-router-dom';
import { apiUrls } from '../../apiUrls.js';
import { useNavigate } from 'react-router-dom';
import MemberSpecification from "../../components/MemberSpecification.js";
import MemberCertificate from "../../components/MemberCertificate.js";
import MemberJoinedProgram from "../../components/MemberJoinedProgram.js";
import MemberLeaderProgram from "../../components/MemberLeaderProgram.js";
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
// const { TabPane } = Tabs;
const { Option } = Select;

const getIranInternationalPhone = (value) => {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
    let phone = String(value || '').replace(/[۰-۹٠-٩]/g, (digit) => {
        const persianIndex = persianDigits.indexOf(digit);
        return String(persianIndex >= 0 ? persianIndex : arabicDigits.indexOf(digit));
    }).replace(/\D/g, '');

    if (phone.startsWith('0098')) phone = phone.slice(2);
    else if (phone.startsWith('0')) phone = `98${phone.slice(1)}`;
    else if (!phone.startsWith('98')) phone = `98${phone}`;

    return phone;
};

const Detail = () => {

    const [data, setData] = useState({});
    const [roleData, setRoleData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [dropDownRoles, setDropDownRoles] = useState([]);
    const [dropDownType, setDropDownTypes] = useState([]);
    const [startMemberingDate, setStartMemberingDate] = useState(null);
    const baseURL = apiUrls.baseURL;
    const navigate = useNavigate();
    const { id } = useParams();
    const permissions = useSelector((state) => state.permissions.permissions);
    const [renderedTabs, setRenderedTabs] = useState([0]);
    const hasChangeRolePermission = permissions.includes('createrole');
    const hasChangeStartDateMemberingPermission = permissions.includes('createmember');

    useEffect(() => {
        fetchData()
        fetchMemberTypes()
    }, [])

    useEffect(() => {
        if (hasChangeRolePermission) {
            fetchRoles()
            fetchUserRoles()
        }
    }, [permissions])

    function callback(key) {

    }

    const onSelect = useCallback((index) => {
        setRenderedTabs((renderedTabs) =>
            renderedTabs.includes(index)
                ? renderedTabs
                : renderedTabs.concat(index)
        )
    }, []);

    const setSelectedStartMemberingDate = async (date) => {
        setStartMemberingDate({
            year: date.year,
            month: date.month,
            day: date.day
        });
        setData({ ...data, startMemberingDate: `${date.year}/${date.month}/${date.day}` })
    }

    const save = async () => {
        setLoadingSave(true);
        try {
            const token = localStorage.getItem('damavandclub-token')
            await axios.post(`${baseURL}/user/updateByOrganizationAdminGroup`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            if (hasChangeRolePermission) {
                await axios.post(`${baseURL}/user/updateroles?id=${id}`, roleData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                });
            }
            toast.success("تغییرات با موفقیت ذخیره شد", {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoadingSave(false);
        } catch (error) {
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setLoadingSave(false);
        } finally {
            setLoadingSave(false);
        }
    }

    const fetchRoles = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/role/getDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

            var result = response.data.data;
            setDropDownRoles(result);
        } catch (error) {
        } finally {
        }
    };

    const fetchUserRoles = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getroles?id=${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })
            var result = response.data.data;
            setRoleData(result.map(x => x.id))
        } catch (error) {
        } finally {
        }
    };

    const fetchMemberTypes = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getTypeDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })
            var result = response.data.data;
            setDropDownTypes(result)
        } catch (error) {
        } finally {
        }
    };

    const fetchData = async () => {
        setLoading(true);
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getUserDetail?id=${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            var result = response.data.data;
            result.id = id;
            var resultStartMemberingDate = result.startMemberingDate.split('/');
            setStartMemberingDate({
                year: parseInt(resultStartMemberingDate[0], 10),
                month: parseInt(resultStartMemberingDate[1], 10),
                day: parseInt(resultStartMemberingDate[2], 10)
            })
            setData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Spin size="large" />
    }

    return (
        <div className='row profile-edit-page'>
            <HideSidebarInMobileMode />
            <div style={{
                backgroundColor: 'white',
                flexDirection: 'column',
                display: 'flex',
                flex: 1,
                height: 'auto',
                padding: 10
            }} className="profile-edit-panel profile-form-fields">
                <div className="profile-save-button-space">
                    <Button className="profile-save-button" onClick={() => save()} loading={loadingSave}
                        type="primary"><label>ذخیره تمام تغییرات پروفایل</label></Button>
                </div>
                <Tabs className="profile-form-tabs" onSelect={onSelect}>
                    <TabList>
                        <Tab>مشخصات</Tab>
                        <Tab>مدارک</Tab>
                        <Tab>حضور در برنامه</Tab>
                        <Tab>سرپرستی ها</Tab>
                    </TabList>

                    <TabPanel forceRender={renderedTabs.includes(0)}>
                        <div className="profile-member-detail-form">
                        <div className="profile-member-legal-names" dir="rtl">
                            <div className="profile-member-insurance-field">
                                <label>نام شناسنامه ای</label>
                                <Input value={data.originalFirstName} onChange={(event) => setData({ ...data, originalFirstName: event.target.value })} size="large" />
                            </div>
                            <div className="profile-member-insurance-field">
                                <label>نام خانوادگی شناسنامه ای</label>
                                <Input value={data.originalLastName} onChange={(event) => setData({ ...data, originalLastName: event.target.value })} size="large" />
                            </div>
                        </div>

                        <MemberSpecification data={data} setData={setData}></MemberSpecification>

                        <div className="profile-member-insurance-row">
                            <div className="profile-member-insurance-field">
                                <label>تاریخ عضویت</label>
                                {hasChangeStartDateMemberingPermission ? <div className='profile-member-start-date'>
                                    <DatePicker
                                        value={startMemberingDate || null}
                                        onChange={(value) => setSelectedStartMemberingDate(value)}
                                        shouldHighlightWeekends
                                        locale='fa'
                                    />
                                </div> : <div className='profile-readonly-value profile-member-start-date' dir="rtl">
                                    <span>{data.startMemberingDate || '—'}</span>
                                </div>}
                            </div>
                            <div className="profile-member-insurance-field">
                                <label>شماره عضویت</label>
                                <Input value={data.memberNumber} onChange={(event) => setData({ ...data, memberNumber: event.target.value })} size="large" />
                            </div>
                            <div className="profile-member-insurance-field">
                                <label>تاریخ اعتبار بیمه ورزشی</label>
                                <div className='profile-readonly-value profile-insurance-expiry' dir="rtl">
                                    <span>{data.insuranceExpiredDate || '—'}</span>
                                </div>
                            </div>
                        </div>

                        <div className="profile-member-type-role-row">
                            <div className="profile-member-insurance-field">
                                <label>انتخاب نوع عضویت</label>
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder="انتخاب نوع عضویت"
                                    onChange={(value) => setData({ ...data, type: value })}
                                    value={data.type}
                                >
                                    {dropDownType?.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.displayName}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            {hasChangeRolePermission ? <div className="profile-member-insurance-field">
                                <label>انتخاب نقش سیستمی</label>
                                <Select
                                    className="profile-role-select"
                                    style={{ width: '100%' }}
                                    placeholder="انتخاب نقش"
                                    mode="multiple"
                                    showSearch
                                    optionFilterProp="label"
                                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                    onChange={(value) => setRoleData(value)}
                                    value={roleData}
                                >
                                    {dropDownRoles?.map((item) => (
                                        <Option key={item.id} label={item.displayName} value={item.id}>
                                            {item.displayName}
                                        </Option>
                                    ))}
                                </Select>
                            </div> : null}
                        </div>

                        <div className="profile-flag-row"><Checkbox checked={data.isActive} onChange={() => setData({ ...data, isActive: !data.isActive })}>اکانت فعال/غیرفعال</Checkbox></div>

                        <div className="profile-flag-row"><Checkbox checked={data.isShareHolder} onChange={() => setData({ ...data, isShareHolder: !data.isShareHolder })}>سهام دار</Checkbox></div>

                        <div className="profile-flag-row"><Checkbox checked={data.isDeaded} onChange={() => setData({ ...data, isDeaded: !data.isDeaded })}>مرحوم</Checkbox></div>

                        <div className="profile-contact-links">
                            <a className="profile-whatsapp-link" rel="noreferrer" target="_blank" href={`https://wa.me/${getIranInternationalPhone(data.phoneNumber)}`} >
                                <FontAwesomeIcon icon={faWhatsapp} aria-hidden="true" />
                                <span>تماس از طریق واتساپ</span>
                            </a>
                            <a className="profile-telegram-link" rel="noreferrer" target="_blank" href={`https://t.me/+${getIranInternationalPhone(data.phoneNumber)}`}>
                                <FontAwesomeIcon icon={faTelegram} aria-hidden="true" />
                                <span>تماس از طریق تلگرام</span>
                            </a>
                            <a className="profile-bale-link" rel="noreferrer" target="_blank" href={`https://ble.ir/${getIranInternationalPhone(data.phoneNumber)}`}>
                                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                    <path d="M12 2.2c-5.6 0-10 3.8-10 8.8 0 2.6 1.2 4.8 3.2 6.4l-.8 3.8 4.4-2.1c1 .3 2.1.5 3.2.5 5.6 0 10-3.7 10-8.6s-4.4-8.8-10-8.8Z" fill="currentColor" />
                                    <text x="12" y="15.4" textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">ب</text>
                                </svg>
                                <span>تماس از طریق بله</span>
                            </a>
                        </div>
                        </div>
                    </TabPanel>
                    <TabPanel forceRender={renderedTabs.includes(1)}>
                        <MemberCertificate isShowButton={true} data={data} setData={setData}></MemberCertificate>
                    </TabPanel>
                    <TabPanel forceRender={renderedTabs.includes(2)}>
                        <MemberJoinedProgram data={data.donedPrograms}></MemberJoinedProgram>
                    </TabPanel>
                    <TabPanel forceRender={renderedTabs.includes(3)}>
                        <MemberLeaderProgram data={data.leaderPrograms}></MemberLeaderProgram>
                    </TabPanel>
                </Tabs>
            </div>
        </div >
    )
}

export default Detail
